export const ONE_DAY_IN_SECS = 86400
export const ONE_YEAR_IN_SECS = ONE_DAY_IN_SECS * 365
